// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* dev/138: a node's last outcome, in the node. One line by default (a node
   body is a few hundred pixels wide), with the rest behind a disclosure.

   It sits over the bottom of the node's content, which reaches the node's
   bottom edge (the run button and the editor tabs are in the header). In the
   flow it would land past the body, where the node's hidden overflow cuts it.
   The offsets are from the \`.resizable\` node box, the nearest positioned
   ancestor; the body inside it is 15px narrower on each side. */

.K5bPQ7bz9dOy6mLsLIQv {
  position: absolute;
  left: 17px;
  right: 17px;
  bottom: 8px;
  z-index: 11;
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 3px 6px;
  border-radius: 6px;
  font-size: 0.7rem;
  line-height: 1.35;
  /* The text is what a user copies first. \`user-select\` alone does not do
     it: the node's drag takes the press unless the strip is \`nodrag\`. */
  user-select: text;
  cursor: auto;
}

/* Opened, it grows upward over the content and scrolls before it reaches the
   header. */
.FSJS_tjbvATRaVvno6os {
  max-height: calc(100% - 56px);
  overflow-y: auto;
  overflow-wrap: anywhere;
}

/* In a notebook cell, which is as tall as its content, the strip is part of
   that content: under the output, never over it. Opened, it grows the cell up
   to a cap and scrolls inside past it. */
.l45KdiN3eizp2ioMr1wA {
  position: static;
  margin: 6px 0 4px;
}

.l45KdiN3eizp2ioMr1wA.FSJS_tjbvATRaVvno6os {
  max-height: 240px;
}

.OHxmBs1N0c7QafCOwCPu {
  background: var(--curio-danger-bg, #fdecec);
  color: var(--curio-danger-text, #8a1f1f);
  border: 1px solid var(--curio-danger-border, #f2c7c7);
}

.y4bjcVx4JTWClAhcoKPW {
  background: var(--curio-surface-muted, #f4f4f5);
  color: var(--curio-text-secondary, #52525b);
  border: 1px solid var(--curio-border, #e4e4e7);
}

.KYr8V7jPtXG3xi_kycaI {
  flex-shrink: 0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  font-size: 0.62rem;
}

.YINWbbarq0D763uIlu58 {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.FSJS_tjbvATRaVvno6os .YINWbbarq0D763uIlu58 {
  white-space: pre-wrap;
  overflow: visible;
}

.jPsbgmVvMrK0lhkN06YD {
  flex-shrink: 0;
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/nodes/NodeOutcomeStrip.module.css"],"names":[],"mappings":"AAAA;;;;;;;gEAOgE;;AAEhE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB;wEACsE;EACtE,iBAAiB;EACjB,YAAY;AACd;;AAEA;YACY;AACZ;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;yCAEyC;AACzC;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB","sourcesContent":["/* dev/138: a node's last outcome, in the node. One line by default (a node\n   body is a few hundred pixels wide), with the rest behind a disclosure.\n\n   It sits over the bottom of the node's content, which reaches the node's\n   bottom edge (the run button and the editor tabs are in the header). In the\n   flow it would land past the body, where the node's hidden overflow cuts it.\n   The offsets are from the `.resizable` node box, the nearest positioned\n   ancestor; the body inside it is 15px narrower on each side. */\n\n.strip {\n  position: absolute;\n  left: 17px;\n  right: 17px;\n  bottom: 8px;\n  z-index: 11;\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  padding: 3px 6px;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  line-height: 1.35;\n  /* The text is what a user copies first. `user-select` alone does not do\n     it: the node's drag takes the press unless the strip is `nodrag`. */\n  user-select: text;\n  cursor: auto;\n}\n\n/* Opened, it grows upward over the content and scrolls before it reaches the\n   header. */\n.expanded {\n  max-height: calc(100% - 56px);\n  overflow-y: auto;\n  overflow-wrap: anywhere;\n}\n\n/* In a notebook cell, which is as tall as its content, the strip is part of\n   that content: under the output, never over it. Opened, it grows the cell up\n   to a cap and scrolls inside past it. */\n.inCell {\n  position: static;\n  margin: 6px 0 4px;\n}\n\n.inCell.expanded {\n  max-height: 240px;\n}\n\n.error {\n  background: var(--curio-danger-bg, #fdecec);\n  color: var(--curio-danger-text, #8a1f1f);\n  border: 1px solid var(--curio-danger-border, #f2c7c7);\n}\n\n.notice {\n  background: var(--curio-surface-muted, #f4f4f5);\n  color: var(--curio-text-secondary, #52525b);\n  border: 1px solid var(--curio-border, #e4e4e7);\n}\n\n.label {\n  flex-shrink: 0;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  font-size: 0.62rem;\n}\n\n.text {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.expanded .text {\n  white-space: pre-wrap;\n  overflow: visible;\n}\n\n.more {\n  flex-shrink: 0;\n  border: none;\n  background: none;\n  padding: 0;\n  font: inherit;\n  color: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strip": `K5bPQ7bz9dOy6mLsLIQv`,
	"expanded": `FSJS_tjbvATRaVvno6os`,
	"inCell": `l45KdiN3eizp2ioMr1wA`,
	"error": `OHxmBs1N0c7QafCOwCPu`,
	"notice": `y4bjcVx4JTWClAhcoKPW`,
	"label": `KYr8V7jPtXG3xi_kycaI`,
	"text": `YINWbbarq0D763uIlu58`,
	"more": `jPsbgmVvMrK0lhkN06YD`
};
export default ___CSS_LOADER_EXPORT___;
